import type { IAgrarianOrder } from '@/types/Order'

const isAgrarianOrder = (order: unknown): order is IAgrarianOrder =>
  Boolean((order as IAgrarianOrder)?.updateDate && (order as IAgrarianOrder)?.id)

export default isAgrarianOrder
